// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MdcVQ{flex:1 1;flex-direction:column;margin-top:1rem;min-height:0}._MILj,.MdcVQ{display:flex;gap:.75rem}._MILj{align-items:center}.zqsFC{color:var(--anchore-color-blue-500);font-size:1.05rem;font-weight:700}.OB3fF.ui.label{background-color:#85b7d914;border:1px solid #85b7d980;border-radius:.3125rem;color:var(--anchore-color-blue-500);font-size:.85rem;font-weight:700;padding:.3rem .6rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"results": `MdcVQ`,
	"header": `_MILj`,
	"query": `zqsFC`,
	"countChip": `OB3fF`
};
module.exports = ___CSS_LOADER_EXPORT___;
